var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartLineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99992H5.33333C5.33333 7.29267 5.61428 6.6144 6.11438 6.1143C6.61448 5.6142 7.29276 5.33325 8 5.33325C8.70724 5.33325 9.38552 5.6142 9.88562 6.1143C10.3857 6.6144 10.6667 7.29267 10.6667 7.99992H16M10.6667 7.99992C10.6667 8.70716 10.3857 9.38544 9.88562 9.88554C9.38552 10.3856 8.70724 10.6666 8 10.6666C7.29276 10.6666 6.61448 10.3856 6.11438 9.88554C5.61428 9.38544 5.33333 8.70716 5.33333 7.99992",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99992H5.33333M5.33333 7.99992C5.33333 7.29267 5.61428 6.6144 6.11438 6.1143C6.61448 5.6142 7.29276 5.33325 8 5.33325C8.70724 5.33325 9.38552 5.6142 9.88562 6.1143C10.3857 6.6144 10.6667 7.29267 10.6667 7.99992M5.33333 7.99992C5.33333 8.70716 5.61428 9.38544 6.11438 9.88554C6.61448 10.3856 7.29276 10.6666 8 10.6666C8.70724 10.6666 9.38552 10.3856 9.88562 9.88554C10.3857 9.38544 10.6667 8.70716 10.6667 7.99992M10.6667 7.99992H16",
    stroke: "currentColor",
    strokeWidth: 1.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLineIcon);
export default __webpack_public_path__ + "static/media/chart_line_icon.8b8fe28f5be9e2ecc10a81561468cc45.svg";
export { ForwardRef as ReactComponent };